import React, { FC, useEffect, useState, Key } from "react";
import { Collapse, Skeleton } from "../../../components";
import { SupplementsEndpoint } from "../../../store/endpoints/supplements";
import { useStore } from "effector-react";
import { $selectedLocation } from "../../../store/selected/selectedLocations";
import { $instancesIds } from "../../../store/selected/shared";
import SupplementGroup from "../SupplementGroup";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../../config";
import { SettingsEndpoint } from "../../../store/endpoints";

const SupplementGroupsList: FC = () => {
  const { t } = useTranslation(AppConfig.translationFileNames.step_Menu);
  const selectedLocation = useStore($selectedLocation);
  const instancesIds = useStore($instancesIds);
  const { data: supplementGroups, pending } = useStore(
    SupplementsEndpoint.listGroups.store
  );

  const [activeCollapse, setActiveCollapse] = useState<Key | Key[] | undefined>(
    undefined
  );

  const { data: settings } = useStore(SettingsEndpoint.store);

  useEffect(() => {
    if (selectedLocation) {
      SupplementsEndpoint.listGroups.call({
        _query: { location_id: selectedLocation.id },
        instances: instancesIds,
      });
    }

    return () => {
      SupplementsEndpoint.listGroups.cancel();
      SupplementsEndpoint.listGroups.reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshCollapseHeight = (key: Key) => {
    setActiveCollapse(undefined);
    setTimeout(() => {
      setActiveCollapse(key);
    }, 0);
  };

  return (
    <>
      <h2>{t("Title")}</h2>
      <p>{settings?.description_supplement_menu}</p>
      {pending ? (
        <SupplementGroupsSkeleton />
      ) : (
        <Collapse
          destroyInactivePanel={false}
          activeKey={activeCollapse}
          onChange={setActiveCollapse}
        >
          {supplementGroups?.map((supplementGroup) => {
            const key = supplementGroup.name + supplementGroup.id;
            return (
              <SupplementGroup
                key={key}
                header={supplementGroup.name}
                data={supplementGroup}
                refreshCollapseHeight={() => {
                  refreshCollapseHeight(key);
                }}
              />
            );
          })}
        </Collapse>
      )}
    </>
  );
};

export default SupplementGroupsList;

const SupplementGroupsSkeleton: FC = () => (
  <>
    <Skeleton height={53} style={{ marginBottom: 10 }} />
    <Skeleton height={53} style={{ marginBottom: 10 }} />
    <Skeleton height={53} style={{ marginBottom: 10 }} />
  </>
);
